import permissions from './permission-list'

export default [
  {
    path: '/preview-image',
    name: 'preview-image',
    component: () => import('@/views/image/Preview.vue'),
    meta: {
      layout: 'full',
      resource: permissions.transaction,
      action: 'read',
    },
  },
]
